import { Validation } from '@ps/web-shared-components';
import { required, validatePNF } from '@ps/web-shared-validators';
import React from 'react';

import TextInput from '../../../../../TextInput/TextInput';

import {
  TXTWCL_Personal_Identification_Number,
  TXTWCL_Please_enter_your_Personal_Num_ELL
} from './PNF.messages.json';

const maxLength = 10;
const minLength = 10;

const PIN: React.FC = () => {
  const parse = (textValue: string) => textValue.replace(/\D+/g, '');

  return (
    <TextInput
      id="pin"
      name="fiscalCode"
      minLength={minLength}
      maxLength={maxLength}
      autoComplete="off"
      placeholder="XXXXXXXX"
      parse={parse}
      label={{ ...TXTWCL_Personal_Identification_Number }}
      validators={[required(TXTWCL_Please_enter_your_Personal_Num_ELL), validatePNF]}
      validationVariant={Validation.Inline}
    />
  );
};

export default PIN;
